<div class="dev-warning-bar" *ngIf="isDevelopmentBuild">
  <span>
    EZ A GLOBODOG TESZT VERZIÓJA! AZ ÉLES OLDALT
    <a href="https://www.globo-dog.com" target="_blank">ITT</a> TALÁLOD!
  </span>
  <span>
    Debug e-mail listához
    <a href="https://dev.globo-dog.com/debug-email-list" target="_blank">IDE</a>
    kattints
  </span>
</div>
<div id="app-container" *ngIf="appLoaded()">
  <app-header></app-header>
  <div id="page-container">
    <ng-container *ngIf="ageOk">
      <router-outlet />
    </ng-container>
    <div id="age-not-ok" *ngIf="!ageOk">
      <h1>{{ 'Életkor ellenőrzése' | translate }}</h1>
      <p>{{ 'Kérjük, add meg a születési dátumodat!' | translate }}</p>
      <p>{{ 'Az oldalon található kutyás tartalmak és szolgáltatások önmagukban nem korhatárosak. A születési dátum
            megadására azért van szükségünk, mert ifjúságvédelmi előírások szerint csak 18. életévüket betöltött
            felhasználók használhatják. Az adatokat nem tároljuk.' | translate }}</p>
      <button (click)="showAgePicker()" mat-flat-button color="primary">
        {{ 'Életkor ellenőrzése' | translate }}
      </button>
    </div>
    <div class="page-loader" [ngClass]="{ hidden: appLoaded() }">
      <img ngSrc="android-chrome-256x256.png" height="256" width="256" priority alt="GloboDog logo." />
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div class="max-width back-btn-cont" *ngIf="canShowBackButton()">
    <button (click)="location.back()" mat-button color="primary">
      {{ 'Vissza' | translate }}
    </button>
  </div>

  <app-footer></app-footer>
</div>


<app-cookie-manager></app-cookie-manager>
<app-gallery></app-gallery>
<app-floating-progress></app-floating-progress>
<app-news></app-news>
